import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import CountUp from 'react-countup';
import Schema from './Schema';

const Statistics = () => {

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
    });
  }, []);

  return (
    <div className="container mx-auto px-4 py-16 sm:px-6 lg:px-8">
    <Schema />
      {/* Heading */}
<section className="px-4 sm:px-6 md:px-12 lg:px-20 py-12 flex flex-col items-center text-center" data-aos="fade-up">
  {/* Section Title */}
  <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-black mb-8">
    Our Achievements
  </h2>

  {/* Highlighted Award Heading */}
  <h3 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-yellow-500 to-red-600">
    Best Solar Preventive Maintenance Provider <br /> in Sri Lanka
  </h3>
  <p className="text-base sm:text-lg text-gray-700 mb-10 max-w-2xl">
    Honored with the prestigious <br />
    <strong>Global Business Excellence Award 2025</strong>
  </p>

  {/* Awards Grid */}
  <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 mb-16 w-full max-w-5xl">
    {/* Award 1 */}
    <div className="flex flex-col items-center">
      <img
        src="https://res.cloudinary.com/dwf8ifbzs/image/upload/v1749487138/Global_Business_Excellence_Award_2025_v2z6jf.png"
        alt="Global Business Excellence Award 2025"
        className="w-28 sm:w-40 md:w-48 mb-4"
      />
      <h4 className="text-xl sm:text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-yellow-600 to-red-600 leading-tight">
        Global Business <br /> Excellence Awards
      </h4>
      <span className="text-lg sm:text-xl font-semibold mt-2">2025</span>
      <span className="text-sm sm:text-base text-gray-800 mt-1 max-w-sm">
        Best Solar Preventive Maintenance Provider in Sri Lanka
      </span>
    </div>

    {/* Award 2 */}
    <div className="flex flex-col items-center">
      <img
        src="https://res.cloudinary.com/dwf8ifbzs/image/upload/v1755780831/ICONIC-AWARDS-2025-Copy_1_t1qwzx.png"
        alt="Iconic Awards 2025"
        className="w-28 sm:w-40 md:w-48 mb-4"
      />
      <h4 className="text-xl sm:text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-yellow-600 to-red-600 leading-tight">
        Iconic Awards
      </h4>
      <span className="text-lg sm:text-xl font-semibold mt-2">2025</span>
      <span className="text-sm sm:text-base text-gray-800 mt-1 max-w-sm">
        Best Solar Preventive Maintenance Provider in Sri Lanka
      </span>
    </div>
  </div>

  {/* Second Highlight */}
  <h3 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-yellow-500 to-red-600">
    Most Innovative Solar Company <br /> of The Year
  </h3>

  {/* Elite Award Row */}
  <div className="grid grid-cols-1 md:grid-cols-1 gap-12 md:gap-16 mb-12 w-full max-w-5xl items-center">
    <div className="flex flex-col items-center">
      <img
        src="https://res.cloudinary.com/dwf8ifbzs/image/upload/v1749487138/Global_Business_Excellence_Award_2025_v2z6jf.png"
        alt="Global Business Excellence Award 2025 Elite"
        className="w-28 sm:w-40 md:w-48 mb-4"
      />
      <h4 className="text-xl sm:text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-yellow-600 to-red-600 leading-tight">
        Global Business <br /> Excellence Awards
      </h4>
      <span className="text-base sm:text-lg font-semibold mt-2">
        2025 – Elite Series II
      </span>
      <span className="text-sm sm:text-base text-gray-800 mt-1 max-w-sm">
        Most Innovative Solar Company
      </span>
    </div>
  </div>

  {/* Closing Statement */}
  <p className="text-lg text-gray-700 font-medium max-w-2xl">
    for our exceptional contribution to sustainable energy solutions.
  </p>
</section>




      {/* Statistics Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 px-4 sm:px-6 mt-16" data-aos="fade-up">
  {[
    { end: 10, label: "Years of Experience", prefix: "Experts with ", suffix: "+" },
    { end: 44000, label: "Completed On Preventive Maintenance", suffix: "kW+" },
    { end: 28, label: "Amazing Brands Collaborations", suffix: "+" },
    { end: 3, label: "Nations for Sri Lanka, India, Maldives", suffix: "+" },
  ].map((item, index) => (
    <div
      key={index}
      className="rounded-2xl p-6 text-center"
      style={{
        background: 'linear-gradient(to right, rgba(161, 196, 253, 0.3), rgba(251, 194, 235, 0.3), rgba(253, 219, 146, 0.3))',
      }}
    >
      <h3 className="text-5xl sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-5xl font-bold tracking-tight leading-snug text-black">
        {item.prefix && (
          <span className="text-xl sm:text-sm md:text-base lg:text-base xl:text-lg 2xl:text-2xl font-bold">{item.prefix}</span>
        )}
        <CountUp start={0} end={item.end} duration={5.5} />
        {item.suffix || ""}
      </h3>
      <p className="mt-2 text-black text-base sm:text-lg">{item.label}</p>
    </div>
  ))}
</div>


    </div>
  );
};

export default Statistics;